import { onSnapshot, doc, Firestore } from 'firebase/firestore';

export function listenToUserNotificationState(
  firestore: Firestore,
  userId: string,
  notificationId: string,
  onUpdate: (isRead: boolean) => void
): () => void {
  const ref = doc(firestore, `users/${userId}/notificationStates/${notificationId}`);
  const unsub = onSnapshot(ref, (snapshot) => {
    onUpdate(snapshot.exists() ? (snapshot.data()?.['read'] ?? false) : false);
  });

  return () => unsub();
}
